// Rekit uses a new approach to organizing actions and reducers. That is
// putting related actions and reducers in one file. See more at:
// https://medium.com/@nate_wang/a-new-approach-for-managing-redux-actions-91c26ce8b5da

import {
  LOGIN_SAP_INICIALIZAR_REGISTRO_LOGIN_SAP,
} from './constants';
import initialState from './initialState';

export function inicializarRegistroLoginSap() {
  return {
    type: LOGIN_SAP_INICIALIZAR_REGISTRO_LOGIN_SAP,
  };
}

export function reducer(state, action) {
  switch (action.type) {
    case LOGIN_SAP_INICIALIZAR_REGISTRO_LOGIN_SAP:
      return {
        ...state,
        registroLoginSap: initialState.registroLoginSap,
        registroAgendamentoRPA: initialState.registroAgendamentoRPA,
      };

    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/features/login-sap/redux/inicializarRegistroLoginSap.js